/* eslint-disable */
import React, {useState} from 'react';
import TextField from '@mui/material/TextField';

export const DebouncedTextField = ({name, label, value, customChange}: any): any => {
    const [text, setText] = useState(value);

    const debounce = (func: any, delay: number) => {
        let timeoutId: any;
        return function (...args: any[]) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleDebouncedChange = debounce((value: any) => {
        if (customChange) customChange(name, value);
    }, 500);

    const handleChange = (event: any) => {
        const value = event.target.value;
        setText(value);
        handleDebouncedChange(value);
    };

    return (
        <TextField
            fullWidth={true}
            name={name}
            label={label}
            value={text}
            onChange={handleChange}
            required={false}
            InputLabelProps={{shrink: true}}
        />
    );
}

export default DebouncedTextField;